import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a3tpqf5bwb: FaireBrandEntity = {
  token: "b_a3tpqf5bwb",
  type: "brand",
  name: "Double Wood Supplements",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ffd016128211cb562d9d93c6b5eb7d9363314e274d94c1db64732d30f8fd200.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a85dc5787f767edd1e8813fcc4003ec31ca15c0207a6f44583564e6fa31c9b2a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9ffd016128211cb562d9d93c6b5eb7d9363314e274d94c1db64732d30f8fd200.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a85dc5787f767edd1e8813fcc4003ec31ca15c0207a6f44583564e6fa31c9b2a.png",
  location: "Sharon Hill, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "First comes transparency, then comes trust.\n\nAs we say, those in-the-know know Double Wood Supplements. By leading with transparency and quality, we’ve earned a reputation as one of the most trusted names in the business by clinicians and supplement enthusiasts alike.\n\nEach of our products is supported with third party testing results, so our customers know exactly what they’re buying, and most importantly, what they’re putting in their bodies. We settle for nothing less than the best quality, and we offer it at an affordable price.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:12.659Z",
    importedBy: "entity-db-cli",
  },
};
